module.exports = __webpack_public_path__ + "static/media/18ECA3.4fe83d9e.jpg";